import React from 'react';
import { TableRow, TableCell, Checkbox, IconButton, Chip } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import dayjs from 'dayjs';

const SkillsTableRow = ({
    skill,
    index,
    perms,
    selectedIds,
    onRowCheckboxClick,
    onMenuOpen,
    page,
    perPage,
    isArabic,
}) => {
    const isSelected = selectedIds.includes(skill.id);

    return (
        <TableRow hover selected={isSelected}>
            <TableCell padding="checkbox">
                <Checkbox
                    checked={isSelected}
                    onClick={(event) => onRowCheckboxClick(event, skill.id)}
                />
            </TableCell>

            {/* S/N */}
            <TableCell align={isArabic ? 'right' : 'left'}>
                {(page - 1) * perPage + index + 1}
            </TableCell>

            {/* الاسم */}
            <TableCell align={isArabic ? 'right' : 'left'} sx={{ fontWeight: 500 }}>
                {isArabic
                    ? (skill?.name?.ar || skill?.name?.en || (typeof skill?.name === 'string' ? skill.name : '-'))
                    : (skill?.name?.en || skill?.name?.ar || (typeof skill?.name === 'string' ? skill.name : '-'))
                }
            </TableCell>

            {/* الحالة */}
            <TableCell align="center">
                <Chip
                    label={skill?.is_active ? (isArabic ? 'نشط' : 'Active') : (isArabic ? 'غير نشط' : 'Inactive')}
                    size="small"
                    color={skill?.is_active ? 'success' : 'default'}
                    variant="outlined"
                    sx={{ borderRadius: '6px' }}
                />
            </TableCell>

            {/* تاريخ الإضافة */}
            <TableCell align={isArabic ? 'right' : 'left'} sx={{ whiteSpace: 'nowrap' }}>
                {skill?.created_at ? dayjs(skill.created_at).format('YYYY-MM-DD') : '-'}
            </TableCell>

            {/* الإجراءات */}
            <TableCell align="center">
                <IconButton onClick={(event) => onMenuOpen(event, skill)}>
                    <MoreVertIcon />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default SkillsTableRow;